import interval from "./interval";
import {durationHour, durationMinute} from "./duration";

var hour = interval(function(date) {
  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
  if (offset < 0) offset += durationHour;
  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
}, function(date, step) {
  date.setTime(+date + step * durationHour);
}, function(start, end) {
  return (end - start) / durationHour;
}, function(date) {
  return date.getHours();
});

export default hour;
export var hours = hour.range;



//////////////////
// WEBPACK FOOTER
// ./~/d3-time/src/hour.js
// module id = 923
// module chunks = 0